<template>
  <div class="home">
    <Documentary> </Documentary>
  </div>
</template>

<script>
// @ is an alias to /src
import Documentary from '../components/Documentary.vue'

export default {
  name: 'Home',
  components: {
    Documentary
  }
}
</script>
